import React, { useContext } from 'react';
import {
  bool, func, oneOf, shape, string
} from 'prop-types';
import classNames from 'classnames/bind';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import {
  StorePod,
  StorePodName,
  StorePodLink,
  StorePodLocalize,
  StorePodRating
} from '@thd-olt-component-react/store-pod';
import { StoreHeroContext } from '../../StoreHero.context';
import styles from './store-hero-header.module.scss';

const cx = classNames.bind(styles);

const StoreHeroHeader = ({
  className,
  font,
  hideActionButton,
  hideRating,
  label,
  onRatingClick
}) => {
  const { hideBackgroundImage, loading, store } = useContext(StoreHeroContext);
  const { storeId } = store || {};
  const { storeId: localizedStoreId } = useStore();
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const triggerLocDrawer = () => {
    document.dispatchEvent(new CustomEvent('launchLocDrawer'));
  };

  const isLocalizedStore = storeId?.replace(/^0+/, '') === localizedStoreId?.replace(/^0+/, '');

  const fontMerged = { ...StoreHeroHeader.defaultProps.font, ...font };

  const wrapperClasses = cx(className, 'store-hero-header', {
    'store-hero-header--dark': hideBackgroundImage,
    'store-hero-header--extra-padding': !hideBackgroundImage
  });

  return (
    <StorePod className={wrapperClasses} loading={loading} store={store}>
      <div className={cx('store-hero-header__row')}>
        <StorePodName
          allowOverflow
          className={cx('store-hero-header__name')}
          font={fontMerged}
          label={label}
          isHeader
        />
        {!isMobile && (
          <button className={cx('store-hero-header__button')} type="button" onClick={triggerLocDrawer}>
            <span>Change Store</span>
          </button>
        )}
      </div>
      {!hideRating && (
        <StorePodRating
          className={cx('store-hero-header__rating')}
          disableTooltip={isMobile}
          onClick={onRatingClick}
        />
      )}
      {isLocalizedStore && !hideActionButton && (
        <StorePodLink type="localAd" visualStyle="button" className={cx('store-hero-header__localize')} />
      )}
      {!isLocalizedStore && !hideActionButton && (
        <StorePodLocalize color="orange" className={cx('store-hero-header__localize')} />
      )}
    </StorePod>
  );
};

StoreHeroHeader.displayName = 'StoreHeroHeader';

StoreHeroHeader.propTypes = {
  className: string,
  font: shape({
    size: oneOf(['medium', 'xlarge']),
    weight: oneOf(['light', 'bold'])
  }),
  hideActionButton: bool,
  hideRating: bool,
  label: string,
  onRatingClick: func
};

StoreHeroHeader.defaultProps = {
  className: null,
  font: {
    size: 'xlarge',
    weight: 'bold'
  },
  hideActionButton: false,
  hideRating: false,
  label: '',
  onRatingClick: () => {}
};

export { StoreHeroHeader };
